import {useRouter} from 'next/router';
import {Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {getLanguage} from '@eksab/util/helpers';

import {OutIcon, PlayerSwapIcon} from './icons';
import type {InvalidReason} from './types';

interface InvalidReasonIndicatorProps {
  reason: InvalidReason;
}

export const InvalidReasonIndicator = ({reason}: InvalidReasonIndicatorProps) => {
  const {locale} = useRouter();

  const t = useTranslate();

  return (
    <Flex flexDir="column" align="flex-end" color="#FFEB00">
      {reason === 'invalid-position' ? (
        <PlayerSwapIcon boxSize="1.125rem" transform="auto" scaleX={getLanguage(locale) === 'en' ? 1 : -1} />
      ) : (
        <OutIcon boxSize="1.125rem" transform="auto" scaleX={getLanguage(locale) === 'en' ? 1 : -1} />
      )}

      <Text as="span" fontSize="sm" color="inherit">
        {t(`fantasy.lineup.invalid-player-warning.reason.${reason}`)}
      </Text>
    </Flex>
  );
};
